<template>
    <div class="position-relative">
        <input 
            id="password" 
            placeholder="Password" 
        
            class="form-control"
            :class="{'is-invalid': error}"
            name="password"
            autocomplete="current-password"
            required

            :type="type"
        >

        <button class="login-page--password-toggle" type="button" @click="visible = !visible">
            <svg-image v-show="!visible" :src="'/svg/' + resource_group +'/eye.svg'"></svg-image>
            <svg-image v-show="visible" :src="'/svg/' + resource_group +'/eye-dash.svg'"></svg-image>
        </button>
    </div>
</template>

<script>
    export default {
		name: "PasswordInput",

        props: {
            error: Boolean
        },

        data: () => {
            return {
                visible: false
            }
        },

        computed: {
            type: function(){
                return this.visible
                    ? 'text'
                    : 'password'
            }
        }
    }
</script>